import { ConnectButton } from "@/react/components/shared/MembersList/CommunityMembers/ActionButtons/ConnectButton";
import { PendingButton } from "@/react/components/shared/MembersList/CommunityMembers/ActionButtons/PendingButton";
import { useDetermineConnectionStatus } from "@/react/components/shared/MembersList/CommunityMembers/hooks/useDetermineConnectionStatus";
import { type CommunityMember } from "@/react/types/CommunityMember";
import { ActiveButton } from "./ActiveButton";
import { RespondButtons } from "./RespondButtons";

export const ConnectionCTA = ({ member }: { member: CommunityMember }) => {
  const memberConnection = member?.connection_to_current_community_member;

  const {
    isEmpty,
    isCurrentUserSentConnection,
    isOtherUserSentConnection,
    isActive,
  } = useDetermineConnectionStatus(memberConnection);

  if (!member.name || !member.public_uid) {
    return null;
  }

  if (isEmpty) {
    return <ConnectButton recipient={member} />;
  }

  if (isActive) {
    return <ActiveButton />;
  }

  if (isCurrentUserSentConnection) {
    return (
      <PendingButton
        memberPublicUid={member.public_uid}
        recipient={member.name}
        connectionId={memberConnection?.id.toString()}
        fullWidth={false}
      />
    );
  }

  if (isOtherUserSentConnection && memberConnection) {
    return (
      <RespondButtons
        memberName={member.name}
        memberPublicUid={member.public_uid}
        connectionId={memberConnection.id.toString()}
      />
    );
  }

  return null;
};
